module.exports = __webpack_public_path__ + "img/about-ch4-sectors-housing.b2176902.png";